import React, { Suspense } from 'react'
import ServiceLocator from 'live/services/service-locator'
import i18n from 'live/services/i18n'
import locale from 'live/init/global-locale'
import { ptBr } from './i18n/ptBr'
import { enUs } from './i18n/enUs'

import { TabServiceType } from './types/external-types'

const localeFiles: Record<string, unknown> = {
    pt_br: ptBr,
    en_us: enUs
}

i18n.add(localeFiles[locale])

/**
 * Lazy-loaded Tab component. The module is only fetched when the component
 * is actually rendered, improving the initial bundle size / startup time.
 */
const LazyTab = React.lazy(() => import('./shifts/Tab').then(module => ({ default: module.Tab })))

/**
 * Thin wrapper that provides the Suspense boundary required by React.lazy.
 * Renders an empty placeholder while the chunk is being fetched.
 */
function TabWithSuspense(props: Record<string, unknown>): React.ReactElement {
    return (
        <Suspense fallback={<div className="loading-shifts" />}>
            <LazyTab {...props} />
        </Suspense>
    )
}

ServiceLocator.getService('asset-tab-service')
    .then((service: unknown): void | PromiseLike<void> => {
        const tabService: TabServiceType = service as TabServiceType
        tabService.register({
            assetType: 'rig',
            step: 'shifts',
            label: i18n('Shifts'),
            shouldHide: false,
            body: TabWithSuspense
        })
    })
    .catch((e: unknown) => console.error('plugin-rig-shifts', e))
